import { tableauV291 } from '/vendor/tableau';

const loadTableauApi = function () {
  return new Promise((resolve, reject) => {
    if (window.tableau) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://dev.tableau.trendence.net/javascripts/api/tableau-2.9.1.min.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Tableau API script'));
    document.head.appendChild(script);
  });
};

const loadTableauVendor = tableauV291;

export { loadTableauApi, loadTableauVendor };